var render, staticRenderFns
import script from "./OnClickOutside.vue?vue&type=script&lang=ts&"
export * from "./OnClickOutside.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf4baac')) {
      api.createRecord('2cf4baac', component.options)
    } else {
      api.reload('2cf4baac', component.options)
    }
    
  }
}
component.options.__file = "src/components/OnClickOutside.vue"
export default component.exports